import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PromisedDonerHistoryContext } from '../PromisedDonerComponent';
import { useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Regex from '../../../Utilities/Regex';
import ButtonLoader from '../../CommonComponent/ButtonLoader/ButtonLoader';
import { agentWalletHistoryAction, promisedHistoryAction } from '../../../Redux/Action/AgentAction';
import { organizationAction } from '../../../Redux/Action/MemberAction';
import Auth from '../../../Utilities/Auth';
import { TiDelete } from 'react-icons/ti';
import { RxCross2 } from 'react-icons/rx';
import PromiseCollectionHistorySearchHandler from '../handler/PromiseCollectionHistorySearchHandler';

function PromisedHistoryForm(props) {

    //ref
    const btnRef = useRef()
    // Hook
    const dispatch = useDispatch()

    // Context
    const {
        promisedDonerHistory,
        setFilteredPromisedCollectionHistory,
        setPromisedDonerHistory,
        setPromisedReload,
        promisedReload
    } = useContext(PromisedDonerHistoryContext)

    //state
    const [organizationList, setOrganizationList] = useState([])
    const user_detail = JSON.parse(Auth.header().userdetail)


    // making active years lifecycle
    // useEffect(() => {
    //     const payload = {
    //         setOrganizationList
    //     }

    //     dispatch(organizationAction(payload))

    // }, [setOrganizationList])

    useEffect(() => {
        //console.log(data)
        const payload = {
            data: {
                agent_id: user_detail?.is_admin ? "" : user_detail?.id,
                row_count: 200
            },
            reset,
            btnRef,
            setPromisedDonerHistory
        }

        dispatch(promisedHistoryAction(payload))
    }, [promisedReload])




    // hook form
    const { register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();

    const onSubmit = data => {
        let permission = JSON.parse(Auth.header().userdetail || "{}")

        // setting agent id
        let agent_id = ""
        if (!user_detail?.is_admin) {
            agent_id = user_detail?.id
        } else if (data.agent_id) {
            agent_id = data.agent_id
        }

        //console.log(data)
        const payload = {
            data: { ...data, agent_id },
            reset,
            btnRef,
            setPromisedDonerHistory
        }

        dispatch(promisedHistoryAction(payload))


    }
    return (
        <>
            {user_detail?.is_admin == "1" && <form className='d-none' onSubmit={handleSubmit(onSubmit)}>
                {/*Agent full_name field*/}
                <Row>
                    {true == false ? <Col md={2} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    defaultValue={200}
                                    type="text"
                                    placeholder="Number of Row"
                                    {...register("row_count", {
                                        required: true,
                                        pattern: Regex.numeric()
                                    })}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("row_count")
                                    document.getElementById("promiseSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.row_count && <span className="text-danger">
                                {errors.row_count.type === "required" && "Please Give Number of Row"}
                                {errors.row_count.type === "pattern" && "Please Give Valid Number of Row"}
                            </span>}
                        </Form.Group>
                    </Col> : ""}

                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Mobile"
                                    {...register("member_phone", {
                                        required: false,
                                    })}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("member_phone")
                                    document.getElementById("promiseSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.member_phone && <span className="text-danger">
                                {errors.member_phone.type === "required" && "Please Give Number of Row"}
                                {errors.member_phone.type === "pattern" && "Please Give Valid Number of Row"}
                            </span>}
                        </Form.Group>
                    </Col>

                    {user_detail?.is_admin == 1 && <Col md={2} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Collector ID"
                                    {...register("agent_id", {
                                        required: false,
                                        pattern: Regex.numeric()
                                    })}
                                />
                                <RxCross2 onClick={e => {
                                    setValue("agent_id")
                                    document.getElementById("promiseSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" />
                            </div>
                            {/* validation message*/}
                            {errors.agent_id && <span className="text-danger">
                                {errors.agent_id.type === "required" && "Please Give Collector Id"}
                                {errors.agent_id.type === "pattern" && "Please Give Valid Collector Id"}
                            </span>}
                        </Form.Group>
                    </Col>}
                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("organization_id")}>
                                <option value="">Select Organization</option>
                                {organizationList.map((singleOrg, index) => (
                                    <option key={index} value={singleOrg.id}>{singleOrg.organization_name}</option>
                                ))}

                            </Form.Select>


                        </Form.Group>
                    </Col>
                    <Col md={2} sm={12}>
                        <Button id='promiseSubmitButton' ref={btnRef} variant="primary" type="submit" className="submit">
                            Submit
                            <ButtonLoader />
                        </Button>
                    </Col>
                </Row>

            </form>}

            <PromiseCollectionHistorySearchHandler preFilteredData={promisedDonerHistory} setFilteredDataState={setFilteredPromisedCollectionHistory} />
        </>
    );
}

export default PromisedHistoryForm;